core.factory('authInterceptor', [ '$q', '$rootScope', 'config', '$cookies',
    function ($q, $rootScope, appConfig, $cookies) {

        var self = this;

        this.token = null;

        $rootScope.$on(Event.AUTH.AUTHENTICATE.SUCCESS, function (event, token) {
            self.token = token;
            $cookies.put('edm-cookie', token);
            sessionStorage.setItem('token', token);
        });

        $rootScope.$on(Event.AUTH.INVALIDATE.SUCCESS, function (event) {
            self.token = null;
            $cookies.remove('edm-cookie');
        });

        if(sessionStorage.getItem('token')) {
            this.token = sessionStorage.getItem('token');
        }

        if($cookies.get('edm-cookie')) {
            this.token = $cookies.get('edm-cookie');
        }

        return {
            request: function(config) {
                if (self.token) {
                    config.headers['X-AUTH-TOKEN'] = self.token;
                }
                return config;
            },
            token: self.token
        };
    }
]);
